import React from "react";
import { useQuery } from "react-query";
import { connect } from "react-redux";
import { Button, Textarea } from "expano-components";
import { Main, Dashboard, Select } from "components";
import { createRemark } from "actions/remarks";
import { Field, reduxForm, SubmissionError } from "redux-form";
import getUsersOptions from "utils/select_options/getUsersOptions";

import { ReactComponent as DangerIcon } from "icons/danger.svg";

const TextAreaField = (props) => <Textarea {...props} />;

const ReportedUserSelect = ({ input, meta, label, options, isLoading }) => (
  <Select
    label={label}
    options={options}
    isLoading={isLoading}
    meta={meta}
    defaultValue={
      input.value ? options?.find(({ value }) => value === input.value) : null
    }
    onChange={input.onChange}
  />
);

const validate = (values) => {
  const errors = {};

  if (!values.content?.trim()) {
    errors.content = "Treść uwagi jest wymagana";
  }

  if (!values.reported_user_id) {
    errors.reported_user_id = "Osoba, której dotyczy uwaga jest wymagana";
  }

  return errors;
};

const RemarkNew = ({ pristine, handleSubmit, history }) => {
  const { isFetching: is_fetching_users, data: users } = useQuery(
    "users",
    getUsersOptions,
  );

  const onSubmit = async (values) => {
    try {
      await createRemark(values);
      history.push("/remarks");
    } catch (error) {
      throw new SubmissionError(error);
    }
  };

  return (
    <Main
      page={{
        name: "Dodaj uwagę",
        icon: <DangerIcon />,
        breadcrumbs: [
          { name: "Uwagi", path: "/remarks" },
          { name: "Dodaj uwagę" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard>
            <form noValidate onSubmit={handleSubmit(onSubmit)}>
              <div className="dashboard__form__submit">
                <Field
                  name="reported_user_id"
                  label="Osoba, której dotyczy uwaga"
                  options={users}
                  isLoading={is_fetching_users}
                  component={ReportedUserSelect}
                />
                <Field
                  name="content"
                  label="Treść uwagi"
                  component={TextAreaField}
                />
              </div>
              <div className="dashboard__form__footer">
                <Button
                  type="cancel"
                  onClick={() => history.push("/remarks")}
                />
                <Button
                  disabled={pristine}
                  text="Utwórz"
                  type="save"
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

export default connect(null)(
  reduxForm({
    form: "new-remark",
    enableReinitialize: true,
    validate,
  })(RemarkNew),
);
